enum InterventionStatus {
  CANCELED = 'CANCELED',
  CREATED = 'CREATED',
  STARTED = 'STARTED',
  IN_PROGRESS = 'IN_PROGRESS',
  PLANNED = 'PLANNED',
  QUALIFIED = 'QUALIFIED',
  COMPLETED = 'COMPLETED',
  SUSPENDED = 'SUSPENDED',
  SYNCHRONIZED = 'SYNCHRONIZED',
  FINISHED = 'FINISHED',
  WORK_REQUEST = 'WORK_REQUEST',
  RELEASED = 'RELEASED',
  WORK_STARTED = 'WORK_STARTED',
  WORK_DONE = 'WORK_DONE',
  VALIDATED = 'VALIDATED',
  NO_STATUS = 'NO_STATUS'
}

export default InterventionStatus;
